module.exports = __webpack_public_path__ + "img/N347-2-EN.18999d1e.png";